import { status } from "src/utils/interfaces/interfaces";

export const IN_TRANSIT = "in_transit";
export const READY = "ready";
export const COMPLETED = "completed";
export const APPROVED = "approved";
export const DRAFT = "draft";
export const CANCELED = "canceled";
export const ACCEPTED = "accepted";
export const PENDING = "pending";
export const PENDING_PAYMENT = "pending_payment";
export const STATUS: status = {
  [DRAFT]: {
    name: "Draft",
  },
  [READY]: {
    name: "Ready",
  },
  [IN_TRANSIT]: {
    name: "In Transit",
  },
  [COMPLETED]: {
    name: "Completed",
  },
  [APPROVED]: {
    name: "Approved",
  },
  reached: {
    name: "Reached",
  },
  complete: {
    name: "Completed",
  },
  canceled: {
    name: "Canceled",
  },
  "": {
    name: "",
  },
};
